export enum AppCountryTier {
  T1 = '1',
  T2 = '2',
  T3 = '3',
  T4 = '4',
}
